import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const SicManagerView = () => import('./SicManagerView.vue');

const SicProjectView = () => import('./SicProjectView.vue');

const AgentHealthView = () => import('./AgentHealthView.vue');

export const routes = [
  {
    path: 'sic_manager',
    name: 'sic_manager',
    component: SicManagerView,
    meta: {
      featureFlag: FEATURE_FLAGS.SIC_MANAGER,
      permissions: ['administrator'],
    },
    children: [
      {
        path: ':projectId',
        name: 'sic_manager_project',
        component: SicProjectView,
        props: true,
      },
    ],
  },
  {
    path: 'agent_health',
    name: 'agent_health',
    component: AgentHealthView,
    meta: {
      featureFlag: FEATURE_FLAGS.SIC_MANAGER,
      permissions: ['administrator'],
    },
  },
];
